import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=4b95aa45&scoped=true"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"
import style0 from "./Page.styl?vue&type=style&index=0&id=4b95aa45&prod&scoped=true&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b95aa45",
  null
  
)

export default component.exports